import React from 'react';
import { CheckBox } from "fw/forms";
import { Col, FormGroup, Row, Button } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { CommentsGrid, AdminAppIdHeader } from 'areas/shared/components';
import * as FormManager from 'fw/forms/form/FormManager';
import * as App from 'modules/app/App';
import * as APIRoutes from 'modules/app/API';
import API from 'fw/system/API';
import AppReviewToolbar from 'areas/admin/certification/shared/AppReviewToolbar';
import { ReviewType, QueueType } from 'areas/shared/consts';
import * as Modals from 'fw/globals/Modals';
import * as Notifications from 'fw/globals/Notifications';
import { ReviewHelpers } from 'areas/shared/helpers';
import DenialConfirmationPopUp from 'areas/admin/certification/shared/DenialConfirmationPopUp';
import DenialCodesPopUp from 'areas/admin/certification/shared/DenialCodesPopUp';

class CertReview extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            reviewComment: '',
            showDenialConfirmation: false,
            showDenialCodesPopUp: false
        }
    }

    updatePostData = (form, dirty) => {
        this.setState({ form });

        if (dirty === true)
            FormManager.dirt(this._form);
    }

    privileges() {
        return {
            add: App.hasPrivilege("AdminCertReviewAccess"),
            edit: App.hasPrivilege("AdminCertReviewAccess")
        }
    }

    isEnabled(data) {
        return (!data.isReviewFinished && this.props.queueTypeCode === "CER") || App.hasPrivilege("AdminFullEditAccess");
    }

    urls() {
        return {
            completeCertification: APIRoutes.Admin.url("/appReview/completeCertification"),
            denyCertification: APIRoutes.Admin.url("/appReview/denyCertification"),
            get: APIRoutes.Admin.url('/certReview/getCertReviewInfo'),
            reviewCompleted: APIRoutes.Admin.url("/certReview/reviewCompleted"),
            reviewNotQualified: APIRoutes.Admin.url("/certReview/reviewNotQualified"),
            loadComments: APIRoutes.Admin.url("/appReview/getComments"),
            save: APIRoutes.Admin.url('/certReview/save')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            content: this.state.reviewComment
        }
    }

    changeStatusReviewRequest() {
        return {
            entityKey: this.props.selectedId,
            entityId: this.state.form.entityId,
            certificationId: this.state.form.certificationId,
            rowVersion: this.state.form.rowVersion,
            fastTrack: this.state.form.fastTrack,
            reviewComment: this.state.reviewComment
        }
    }

    completeCertificationReviewRequest(rq) {
        if (rq == null)
            rq = {};

        return {
            entityKey: this.props.selectedId,
            entityId: this.state.form.entityId,
            certificationId: this.state.form.certificationId,
            rowVersion: this.state.form.rowVersion,
            reviewComment: this.state.reviewComment,
            reviewTypeCode: 'CTR',
            reviewQueueTypeCode: 'CER',
            // Denial code fields
            denialCode1Id: rq.denialCode1Id || null,
            denialCode2Id: rq.denialCode2Id || null,
            denialCode3Id: rq.denialCode3Id || null,
            applicationDays: rq.applicationDays || null,
            isRefunded: rq.isRefunded !== undefined ? rq.isRefunded : null
        }
    }

    openEmailDialog = () => {
        let to = this.state.form.primaryContactEmail;
        let subject = "VOCS - Certification Denied";
        let message = this.state.form.requestConnectionTemplateBody;

        this.setState({
            emailDialog: true,
            emailDialogTo: to,
            emailDialogSubject: subject,
            emailDialogMessage: message
        });
    }

    closeEmailDialog = () => {
        this.setState({
            emailDialog: false
        });
    }

    handleReviewCompleted = () => {
        const me = this;
        this.beforeSave(() => {
            me.reviewCompleted();
        });
    }

    handleReviewNotQualified = () => {
        const me = this;
        this.beforeSave(() => {
            me.reviewNotQualified();
        });
    }

    handleApproveCertification = () => {
        const me = this;
        this.beforeSave(() => {
            me.approveCertification();
        });
    }

    confirmApproveCertification = (rq) => {
        Modals.confirm("You are about to <b>approve</b> this Application, this action cannot be undone.<br /><br />"
            + "If you wish to continue with this action please select 'Yes'.<br /><br /> If you wish to cancel, please select 'No', and you will be returned to the previous screen.",
                this.handleApproveCertification
            );
    }

    confirmDenyCertification = () => {
        this.setState({ showDenialConfirmation: true });
    }

    onDenialConfirmationCancel = () => {
        this.setState({ showDenialConfirmation: false });
    }

    onDenialConfirmationProceed = () => {
        this.setState({
            showDenialConfirmation: false,
            showDenialCodesPopUp: true
        });
    }

    onDenialCodesCancel = () => {
        this.setState({ showDenialCodesPopUp: false });
    }

    onDenialCodesSave = (denialData) => {
        this.setState({ showDenialCodesPopUp: false });
        const me = this;
        this.beforeSave(() => {
            me.denyCertification(denialData);
        });
    }

    handleDenyCertification = (rq) => {
        const me = this;
        this.beforeSave(() => {
            me.denyCertification(rq);
        });
    }

    handleAppReviewToolbar = (comments, canCompleteReview) => {
        this.handleUpdateComments(comments, canCompleteReview);
    }

    handleCommentsGrid = (comments) => {
        this.setState({ reviewComment: '' });
        this.handleUpdateComments(comments, true);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments, canCompleteReview) {
        let form = this.state.form;
        form.comments = comments;
        form.canCompleteReview = canCompleteReview;

        this.setState(form);
    }

    loadComments = () => {
        let rq = {
            certificationId: this.state.form.certificationId,
            queueTypeCode: ReviewType.CERTIFICATION_REVIEW.code,
        };

        new API().get(this.urls().loadComments, rq,
            {
                success: (r) => {
                    let form = this.state.form;
                    form.comments = r.data.comments;
                    form.canCompleteReview = r.data.canCompleteReview;

                    this.setState(form);
                }
            });
    }

    finishReview = (rq, url) => {
        new API().post(url, rq, {
            success: (r) => {
                this.setState({
                    saving: false,
                    dirty: false,
                    form: {
                        ...this.state.form,
                        ...r.data,
                        original: {
                            ...this.state.form,
                            ...r.data
                        }
                    }
                }, () => { if (r.data.shouldUpdateComments) this.loadComments() });

                this.afterSave(r.data.entityId);
                this.props.onSuccess(r.message);
                this.props.onSave(r.data.entityId);
                FormManager.reset();
            },
            error: r => {
                this.setState({ saving: false });
                this.props.onError(r.error);
            }
        })
    }

    reviewCompleted = () => {
        let url = this.urls().reviewCompleted;
        let rq = this.changeStatusReviewRequest();

        this.finishReview(rq, url);
    }

    reviewNotQualified = () => {
        let url = this.urls().reviewNotQualified;
        let rq = this.changeStatusReviewRequest();

        this.finishReview(rq, url);
    }

    approveCertification = () => {
        this.completeAllReviews(true);
    }

    denyCertification = (rqEmail) => {
        this.completeAllReviews(false, rqEmail);
    }

    completeAllReviews = (isApproved, rqEmail) => {
        // Proceed
        const me = this;
        let url = "";
        let rq = {};

        if (isApproved)
            url = this.urls().completeCertification;
        else
            url = this.urls().denyCertification;

        rq = this.completeCertificationReviewRequest(rqEmail);

        this.setState({
            saving: true
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    let form = this.state.form;

                    form.finalApprovalDenial = false;
                    this.setState({
                        saving: false,
                        dirty: false,
                        form: { ...form, isReviewFinished: true }
                    }, () => { if (r.data.shouldUpdateComments) this.loadComments() });

                    this.afterSave(r.data.entityId);
                    this.props.onSuccess(r.message);
                    this.props.onSave(r.data.entityId);
                    FormManager.reset();
                },
                error: r => {
                    me.setState({ saving: false });
                    this.props.onError(r.error);
                }
            })
        });
    }

    ready = () => {
        if (!this.state.form.queueAssigned)
            Notifications.error("Cert Review is currently unassigned.");
        this.focusControl && this.focusControl.focus();
    }

    afterSave = (entityId) => {
        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });
    }

    renderButtons = () => {
        if (!this.state.form.queueAssigned)
            return null;

        return (
            <React.Fragment>
                <hr />
                {ReviewHelpers.renderFinalDenialEmailDialog(this.state, this.closeEmailDialog, this.handleDenyCertification)}
                <Row>
                    <Col md={2}>
                        {App.hasPrivilege("AdminFinalApprovalDenial") ?
                            <React.Fragment>
                                <Button bsStyle="default" className="btn-block" onClick={this.confirmDenyCertification}
                                    disabled={!this.state.form.finalApprovalDenial}>Deny Certification</Button>
                                <DenialConfirmationPopUp
                                    visible={this.state.showDenialConfirmation}
                                    onCancel={this.onDenialConfirmationCancel}
                                    onDenialCodes={this.onDenialConfirmationProceed}
                                />
                                <DenialCodesPopUp
                                    visible={this.state.showDenialCodesPopUp}
                                    certificationId={this.state.form.certificationId}
                                    onCancel={this.onDenialCodesCancel}
                                    onSave={this.onDenialCodesSave}
                                />
                            </React.Fragment>
                            : null}
                    </Col>
                    <Col md={2}>
                        {App.hasPrivilege("AdminFinalApprovalDenial") ?
                            <Button bsStyle="primary" className="btn-block" onClick={this.confirmApproveCertification}
                                disabled={!this.state.form.finalApprovalDenial}>Approve Certification</Button>
                            : null}
                    </Col>
                    <Col md={2}>
                    </Col>
                    <Col md={2}>
                        <AppReviewToolbar
                            disabled={this.state.form.isReviewFinished}
                            queueTypeCode={'CER'}
                            reviewTypeCode={'CTR'}
                            comments={this.state.form.comments}
                            onFlagSave={this.handleAppReviewToolbar}
                            certificationKey={this.props.selectedId} />
                    </Col>
                    <Col md={2}>
                        {(this.state.privileges.edit) && <Button id="btnNotQualified" bsStyle="danger" className="btn-block"
                            disabled={this.state.form.isReviewFinished}
                            onClick={this.handleReviewNotQualified}>Not Qualified</Button>}
                    </Col>
                    <Col md={2}>
                        {(this.state.privileges.edit) && <Button id="btnComplete" bsStyle="success" className="btn-block"
                            onClick={this.handleReviewCompleted}
                            disabled={!this.state.form.canCompleteReview || this.state.form.isReviewFinished}>Recommend</Button>}
                    </Col>
                </Row>
                <hr style={{ marginTop: 5, marginBottom: 5 }} />
                <Row>
                    <Col md={12}>
                        {ReviewHelpers.renderAdminStepToolbar(ReviewType.CERTIFICATION_REVIEW.code, QueueType.CERTIFICATION_REVIEW.code, this.state.form, this.props, this._ast )}
                    </Col>
                </Row>

            </React.Fragment>
        );
    }

    renderStatusCheckboxes() {
        var me = this;
        
        var reviewTypesList = ReviewType.REVIEW_TYPES.map(function (reviewType, index) {
            if (me.state.form.certificationSteps.includes(reviewType.code))
                return <React.Fragment key={index}>{me.renderStatusCheckbox(reviewType)}</React.Fragment>;
			else
				return null;
        });

        return (
            <Col md={9}>
                <Row>
                    {reviewTypesList}
                </Row>
            </Col>
        );
    }

    renderStatusCheckbox(reviewType) {
        const name = reviewType.systemName + "Completed";
        return (
            <Col md={4}>
                <FormGroup>
                    <CheckBox inline name={name} label={reviewType.description} disabled="true" />
                </FormGroup>
            </Col>
        );
    }

    renderForm() {
        let me = this;
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3 style={{ marginTop: "0px", position: "relative" }}>
                                    <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                                </h3>
                                <hr />
                                <h3 style={{ marginTop: "0px" }}>
                                    Certification Review
                                    {ReviewHelpers.renderAdminStepToolbar(ReviewType.CERTIFICATION_REVIEW.code, QueueType.CERTIFICATION_REVIEW.code, this.state.form, this.props, this._ast )}
                                </h3>
                            </Col>
                            <Col md={4}>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <hr />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    {me.renderStatusCheckboxes()}
                </Row>
                <Row>
                    <CommentsGrid
                        ref={(c) => { this._commentsGrid = c }}
                        comments={this.state.form.comments}
                        documents={this.state.form.reviewDocuments}
                        certificationKey={this.props.selectedId}
                        reviewTypeCode={"CTR"}
                        queueTypeCode={"CER"}
                        enableExport={true}
                        entityId={this.state.form.entityId}
                        readonly={!this.state.privileges.edit || !this.state.enabled || !this.state.form.queueAssigned}
                        onSave={this.handleCommentsGrid}
                        onCommentChange={this.handleCommentChange}
                        showAddButton={true} />
                </Row>
            </React.Fragment>
        )
    }
}

export default CertReview;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certReview/CertReview.js